<template>
  <data-manager-layout>
    <template #actions>
      <el-button
        v-if="!readonly"
        type="primary"
        icon="el-icon-circle-plus"
        @click="addRow"
      >
        {{ $t('DataManager_Button_CreateTagCategory') }}
      </el-button>
    </template>

    <rest-list-editable
      :payload="fetchEndpoint"
      ref="rest-list-editable"
      :rules="rules"
      :add-endpoint="rowAddEndpoint"
      :update-endpoint="rowUpdateEndpoint"
    >
      <rest-list-column
        prop="name"
        :title="$t('DataManager_TagCategories_Field_Name')"
        :editable="true"
      >
        <template #input-edit="{ model }">
          <el-input v-model="model.name" :disabled="Boolean(model.id)" />
        </template>

        <template #default="{ row }">
          {{ row.name }}
        </template>
      </rest-list-column>

      <rest-list-column
        prop="display_name"
        :title="$t('DataManager_TagCategories_Field_DisplayName')"
        :editable="true"
      />

      <rest-list-column
        prop="created_by_name"
        :title="$t('DataManager_TagCategories_Field_CreatedBy')"
        :sortable="false"
        :filterable="false"
      />

      <rest-list-column
        prop="updated_by_name"
        :title="$t('DataManager_TagCategories_Field_UpdatedBy')"
        :sortable="false"
        :filterable="false"
      />

      <rest-list-column-date
        prop="create_time"
        :unix="true"
        :title="$t('DataManager_TagCategories_Field_CreatedDate')"
        :sortable="true"
        :filterable="true"
        :min-width="200"
        :convert-to-utc="true"
      />

      <rest-list-column-date
        prop="update_time"
        :unix="true"
        :title="$t('DataManager_TagCategories_Field_LastUpdated')"
        :sortable="true"
        :filterable="true"
        :min-width="200"
        :convert-to-utc="true"
      />

      <el-table-column
        :width="50"
        align="center"
        class-name="editable-row-actions"
        :fixed="false"
      >
        <template #default="{ row, $index }" v-if="!readonly">
          <rest-list-action-edit :index="$index" icon="el-icon-more">
            <rest-list-action-delete
              :endpoint="rowDeleteEndpoint(row)"
              :name="row.name"
              :html-warning-msg="true"
            />
          </rest-list-action-edit>
        </template>
      </el-table-column>
    </rest-list-editable>
  </data-manager-layout>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint } from '@/core/helpers'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import DataManagerLayout from '@/modules/data-manager/pages/DataManagerLayout'
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListActionEdit from '@/common/components/rest/RestListActionEdit'

export default {
  name: 'DataManagerTagCategoriesPage',

  components: {
    RestListActionEdit,
    RestListEditable,
    DataManagerLayout,
    RestListActionDelete,
    RestListColumn,
    RestListColumnDate
  },

  data() {
    return {}
  },

  computed: {
    rules() {
      return {
        name: {
          required: true,
          trigger: 'blur',
          message: this.$t('TagCategories_Name_Required')
        },
        display_name: {
          required: true,
          trigger: 'blur',
          message: this.$t('TagCategories_DisplayName_Required')
        }
      }
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tag-categories`,
        params: {
          sort: 'name'
        }
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `tag-categories`
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    addRow() {
      const model = {}
      this.$refs['rest-list-editable'].addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `tag-categories/${row.id}`
      })
    },

    rowUpdateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `tag-categories/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerTagCategoriesPage.vue